import React, { useState, useEffect } from 'react';
import { obtenerPlantillas, eliminarPlantilla } from '../../services/PlantillasServicio';
import config from '../../config/apiConfig';

const TemplateManagerModal = ({ isVisible, onClose, onApplyTemplate }) => {
    const [plantillas, setPlantillas] = useState([]);
    const [cargando, setCargando] = useState(false);

    const cargarDatos = () => {
        setCargando(true);
        obtenerPlantillas().then(data => {
            setPlantillas(Array.isArray(data) ? data : []);
            setCargando(false);
        });
    };

    useEffect(() => {
        if (isVisible) cargarDatos();
    }, [isVisible]);

    const handleBorrar = async (id, nombre) => {
        if (window.confirm(`¿Estás seguro de eliminar la plantilla "${nombre}"?`)) {
            try {
                await eliminarPlantilla(id);
                // Filtramos la lista para que desaparezca visualmente al tiro
                setPlantillas(plantillas.filter(p => p.id !== id));
            } catch (error) {
                alert("Error al eliminar: " + error.message);
            }
        }
    };

    // Ejemplo de cómo debería ser tu función de envío
    const handleUpdatePlantilla = async (plantillaEditada) => {
        // 1. Preguntar al usuario si quiere propagar
        const quierePropagar = window.confirm(
            "¿Deseas aplicar estos cambios a TODOS los productos que ya usan esta plantilla? " +
            "(Esto sobrescribirá precios y opciones en esos productos)"
        );

        const payload = {
            ...plantillaEditada,
            propagar: quierePropagar // Enviamos el flag al backend
        };

        try {
            const response = await fetch(`${config.api_url}/api/variantes-plantillas/${plantillaEditada.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token')
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert("Plantilla actualizada correctamente");
                // Recargar lista de plantillas...
            }
        } catch (error) {
            alert("Error: " + error.message);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1100 }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg">
                    <div className="modal-header bg-dark text-white">
                        <h5 className="modal-title font-weight-bold">Mis Plantillas</h5>
                        <button type="button" className="close text-white" onClick={onClose}><span>&times;</span></button>
                    </div>

                    <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {cargando ? (
                            <div className="text-center p-4">Cargando...</div>
                        ) : plantillas.length === 0 ? (
                            <div className="alert alert-info text-center">No hay plantillas.</div>
                        ) : (
                            <div className="list-group">
                                {plantillas.map((p) => {
                                    const nombre = p.nombre_plantilla || p.nombre || p[2] || "Sin nombre";
                                    return (
                                        <div key={p.id} className="list-group-item d-flex justify-content-between align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="mb-0 font-weight-bold">{nombre}</h6>
                                                <small className="text-muted">{p.tipo_seleccion || "Múltiple"}</small>
                                            </div>
                                            <div className="d-flex">
                                                <button className="btn btn-sm btn-primary mr-2 px-3" onClick={() => onApplyTemplate(p)}>Aplicar</button>
                                                {/* BOTÓN ELIMINAR */}
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleBorrar(p.id, nombre)}>
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer bg-light">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateManagerModal;